import React from 'react';
import './footer.css';

function Footer () {
  return (
    <footer className="site-footer">
      <p>
        &copy;{new Date().getFullYear()} <a href="https://inputsenpai.com" target="_blank">inputsenpai</a><br/>
        Like our work? <a target="_blank" rel="noopener noreferrer" href="https://www.buymeacoffee.com/njosefbeck">Buy us a tea</a> or <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/inputsenpai">follow us on Twitter</a>.<br/><br/>
        Books copyright their respective authors and publishers.<br/>
        Thanks to <a href="https://www.ehonnavi.net" target="_blank" rel="noopener noreferrer">ehonnavi.net</a> for making these books available. Book icon from <a href="http://www.iconarchive.com/show/office-icons-by-thalita-torres/school-book-icon.html" target="_blank" rel="noopener noreferrer">here</a>. Mountain background from <a href="https://all-free-download.com/free-vector/download/mountain-range-background_312045.html" target="_blank" rel="noopener noreferrer">here</a>.</p>
    </footer>
  );
}

export default Footer;